import client from '@/apis/client';
import type { Response } from '@/types/client.types';
import type { TargetCategoryResponseProps } from '@/types/template.types';

export const getPrimaryCategory = () =>
  client
    .get<Response<TargetCategoryResponseProps>>('/template/category-primary')
    .then((res) => res.data)
    .catch((error) => {
      console.error('Error fetching primary category:', error);
      throw error;
    });

export const getSubCategory = (id: number) =>
  client
    .get<Response<TargetCategoryResponseProps>>('/template/category', {
      params: { id },
    })
    .then((res) => res.data)
    .catch((error) => {
      console.error('Error fetching sub category:', error);
      throw error;
    });
